export function normalizePolicyActionsForSave(actions: unknown): any[] {
  if (!Array.isArray(actions)) return [];
  return actions.filter((action) => action && typeof action === 'object');
}
